<template>
    <g>
        <path
            d="M7.5 15L12.5 10L7.5 5"
            :stroke="iconFill"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
</template>
<script>
export default {
    name: "ChevronRight2020",
    props: {
        iconFill: {
            type: String,
            default: "#C8D0DD",
        },
    },
};
</script>
